import React, { useState } from 'react'
import PageHeader from '../../partials/PageHeader'
import { Color } from '../../utils/constants'
import Background from '../../assets/backgrounds/contact.svg'
import BackgroundMobile from '../../assets/backgrounds/applications-mobile.svg'
import HowItWorks from './components/HowItWorks'
import InformationBlock from '../../partials/InformationBlock'
import Segments from './components/Segments/Segments'
import Solutions from './components/Solutions'
import Reimagined from './components/Reimagined/Reimagined'
import LinkCards from '../../partials/LinkCards/LinkCards'
import PaddingContext, { PaddingProps } from '../../utils/PaddingContext'

const Applications = () => {
    const [padding, setPadding] = useState<PaddingProps>()
    return (
        <PaddingContext.Provider value={{ padding }}>
            <PageHeader
                title='page.applications.title'
                description='page.applications.description'
                bgColor={Color.GREEN_LIGHT}
                component={Background}
                mobileComponent={BackgroundMobile}
                link={'/'}
            />
            <div className='bg-white'>
                <HowItWorks setPadding={setPadding} />
                <Segments />
                <Solutions />
                <Reimagined />
                <InformationBlock
                    title='page.applications.partnering'
                    description='page.applications.partnering.description'
                    link='/partnerships'
                />
                <LinkCards
                    title1='section.linkCard.contactUs'
                    link1='/contact'
                    title2='page.careers.become'
                    link2='https://careers.biomatter.ai/'
                    external2={true}
                />
            </div>
        </PaddingContext.Provider>
    )
}

export default Applications
